<template>
    <header>
        <div class="topbar d-flex align-items-center">
            <nav class="navbar navbar-expand gap-3">
                <div class="mobile-toggle-menu"><i class='bx bx-menu'></i>
                </div>
                <div class="search-bar px-0 font-18">
                    <a class="d-flex align-items-center nav-link gap-3" href="javascript:;" role="button"
                        @click="changeMenu('default')">
                        <div class="user-info">
                            <i class="bx bx-calendar"></i> Vue d'ensemble
                        </div>
                    </a>
                </div>

                <div class="top-menu ms-auto">
                    <ul class="navbar-nav align-items-center gap-1">
                        <li class="nav-item dark-mode d-none d-sm-flex" @click="toggleDarkMode">
                            <a class="nav-link dark-mode-icon" href="javascript:;">
                                <i :class="darkModeIconClass"></i>
                            </a>
                        </li>
                        <li v-if="parameters.length > 0" class="nav-item dropdown dropdown-app">
                            <a class="nav-link dropdown-toggle dropdown-toggle-nocaret" data-bs-toggle="dropdown"
                                href="javascript:;" @click="toggleDropdown('.top-menu .dropdown-toggle')"><i
                                    class='bx bx-grid-alt'></i></a>
                            <div class="dropdown-menu dropdown-menu-end p-0">
                                <div class="app-container p-2 my-2">
                                    <div class="row gx-0 gy-2 row-cols-3 justify-content-center p-2">
                                        <div v-for="(parameter, index) in parameters" :key="index"
                                            v-show="parameter.show" class="col">
                                            <a href="javascript:;" @click="changeMenu(parameter.type)">
                                                <div class="app-box text-center">
                                                    <div class="app-icon">
                                                        <Icons type="bx" :icon="parameter.icon" class="font-30" />
                                                        <!-- <img :src="parameter.img" width="30" alt=""> -->
                                                    </div>
                                                    <div class="app-name">
                                                        <p class="mb-0 mt-1">{{ parameter.name }}</p>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="user-box dropdown px-3">
                    <a class="d-flex align-items-center nav-link dropdown-toggle gap-3 dropdown-toggle-nocaret"
                        href="javascript:;" role="button" data-bs-toggle="dropdown" aria-expanded="false"
                        @click="toggleDropdown('.user-box .dropdown-toggle')">
                        <!-- <img src="/assets/images/avatars/avatar-2.png" class="user-img" alt="user avatar"> -->
                        <div class="user-info">
                            <p class="user-name mb-0">{{ username }}</p>
                            <p class="designattion mb-0">{{ rules }}</p>
                        </div>
                    </a>
                    <ul class="dropdown-menu dropdown-menu-end">
                        <li v-for="(profile, index) in profiles" :key="index" v-show="profile.show">
                            <router-link :to="profile.url" :class="profile.class">
                                <i :class="profile.icon"></i><span>{{ profile.name }}</span>
                            </router-link>
                        </li>
                        <div class="dropdown-divider mb-0"></div>
                        <li>
                            <a @click.prevent="Logout" class="dropdown-item d-flex align-items-center"
                                href="javascript:;">
                                <i class="bx bx-log-out-circle"></i><span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </div>

            </nav>
        </div>
    </header>
</template>

<script setup>
import { computed, onMounted, ref, watch, watchEffect } from 'vue';
import { userConf } from '../configs/userConfig';
import { useRouter } from 'vue-router';
import Icons from '../plugins/Icons.vue';
import { paramsConf } from '../configs/paramsConfig';
import { useMenusStore } from '@/stores/sidebar';
import { Dropdown } from 'bootstrap';
import { showError } from '@/utils/toastr';

const username = computed(() => sessionStorage.getItem('username'));
const rules = computed(() => sessionStorage.getItem('rules'));

const profiles = ref([]);
const parameters = ref([]);
const router = useRouter();
const menuStore = useMenusStore();

const Logout = () => {
    router.push('/logout');
}

const changeMenu = (display) => {
    menuStore.redirectUrl(display, router);
}

const initializeUser = () => {
    profiles.value = userConf;
    parameters.value = paramsConf;
}

const darkMode = ref(document.documentElement.classList.contains('dark-theme'));
const darkModeIconClass = computed(() => darkMode.value ? 'bx bx-sun' : 'bx bx-moon');

const toggleDarkMode = () => {
    const html = document.documentElement;
    if (darkMode.value) {
        html.classList.remove('dark-theme');
        html.classList.add('light-theme');
        html.classList.add('color-sidebar');
        html.classList.add('sidebarcolor3');
    } else {
        html.classList.add('dark-theme');
        html.classList.remove('light-theme');
        html.classList.remove('color-sidebar');
        html.classList.remove('sidebarcolor3');
    }
    darkMode.value = !darkMode.value;
}

const toggleDropdown = (target) => {
    const dropdown = document.querySelector(target);
    if (dropdown) {
        if (typeof Dropdown === 'undefined') {
            showError("Bootstrap n'est pas chargé correctement");
            return;
        }

        const bootstrapDropdown = new Dropdown(dropdown);
        bootstrapDropdown.toggle();
    }
}

onMounted(() => {
    initializeUser();
});

watchEffect(() => {
    darkMode.value = document.documentElement.classList.contains('dark-theme');
})
</script>